export const QueueStatus = {
	QUEUED: "queued",
	UPLOADING: "uploading",
	CANCELED: "canceled",
	ERROR: "error",
	SUCCESS: "success",
	ADDED: "added"
};
